/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MapCampaignColumnsCommand } from '../../models/map-campaign-columns-command';
import { MapCampaignColumnsResult } from '../../models/map-campaign-columns-result';

export interface ApiCampaignsCampaignIdMapColumnsPost$Params {
  campaignId: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: MapCampaignColumnsCommand
}

export function apiCampaignsCampaignIdMapColumnsPost(http: HttpClient, rootUrl: string, params: ApiCampaignsCampaignIdMapColumnsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MapCampaignColumnsResult>> {
  const rb = new RequestBuilder(rootUrl, apiCampaignsCampaignIdMapColumnsPost.PATH, 'post');
  if (params) {
    rb.path('campaignId', params.campaignId, {});
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MapCampaignColumnsResult>;
    })
  );
}

apiCampaignsCampaignIdMapColumnsPost.PATH = '/api/campaigns/{campaignId}/map-columns';
